<template>
  <JobProfileSearch
    v-model="localInputValue"
    :page-loading="pageLoading"
    :text-filter="textFilter"
    @submit="submitSearch"
    @clear="clearSearch"
  />
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useFilters } from '@/stores/filters/filters';
import { useJobProfiles } from '@/stores/jobProfiles/jobProfiles';
import JobProfileSearch from '@/components/jobProfiles/JobProfileSearch.vue';
import { useTracking } from '@/stores/tracking/tracking';
import { JP_PAGE_PUBLISHED_LIBRARY } from '@/helpers/jobProfileLibraryTracking';

const router = useRouter();

const { sendFilterRequest } = useFilters();
const { textFilter } = storeToRefs(useJobProfiles());
const { setTextFilter } = useJobProfiles();
const { pageLoading } = storeToRefs(useAppLoading());
const localInputValue = ref('');

const submitSearch = () => {
  const value = (localInputValue.value).trim();

  setTextFilter(value);

  if (value) {
    useTracking().jpLibAppliedTextSearch({
      page: JP_PAGE_PUBLISHED_LIBRARY,
    });
  }

  sendFilterRequest({ router });
};

const clearSearch = () => {
  setTextFilter('');

  localInputValue.value = '';

  sendFilterRequest({ router });
};

watch(() => textFilter.value, (newVal, oldVal) => {
  const newSearchTerm = newVal || '';
  const oldSearchTerm = oldVal || '';

  if (newSearchTerm !== oldSearchTerm) {
    localInputValue.value = newSearchTerm;
  }
});
</script>
